import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {UserService} from 'src/shared/services/user/user.service';

@Component({
  selector: 'app-dialog-login',
  templateUrl: './dialog-login.component.html',
  styleUrls: ['./dialog-login.component.scss']
})
export class DialogLoginComponent implements OnInit {
  public loading: boolean;
  public error: string;
  public loadingRequest: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogLoginComponent>,
    public user: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadingRequest = false;
  }
  public onLogin(userForm) {
    this.loadingRequest = true;
    this.loading = true;
    this.error = '';

    this.user
      .login(userForm)
      .then(res => {
        // Si tout est OK, on redirige vers l
        if (!res) {
          return;
        }
        this.dialogRef.close(res);
      })
      .finally(() => (this.loading = false));
  }
}
